import { Route } from "react-router-dom";
import { SetAnnouncement } from "../Announcements/Announcement";

export const ANNOUNCEMENT_ROUTES = [
    <Route key="announcements-create" path="/announcements/create_anncouncement" element={<SetAnnouncement />} />
];
